import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserProfile } from '../../../../types/types';
import { AppSyncUser } from '../../../../services/auth/types/user';
import Avatar from '../../../../components/shared/Avatar/Avatar';
import './Overview.css';

interface OverviewProps {
  user: UserProfile;
  appSyncUser: AppSyncUser | null;
}

const Overview: React.FC<OverviewProps> = ({ user, appSyncUser }) => {
  const navigate = useNavigate();
  const [adventureText, setAdventureText] = React.useState('');

  const handleStartPlanning = () => {
    navigate('/v2/plan');
  };

  const handlePostAdventure = () => {
    if (adventureText.trim()) {
      console.log('Posted adventure:', adventureText);
      setAdventureText('');
      // TODO: Add actual post functionality
    }
  };

  const userPicture = appSyncUser?.picture_url || appSyncUser?.avatarUrl || user?.avatar || undefined;

  const tripPosts = [
    {
      id: 1,
      author: 'Sarah Johnson',
      avatar: '👩‍🦰',
      location: 'Paris, France',
      image: '🗼',
      description: 'Amazing sunset view from the Eiffel Tower! The city of lights never disappoints.',
      likes: 124,
      comments: 18,
      time: '2 hours ago'
    },
    {
      id: 2,
      author: 'Mike Chen',
      avatar: '👨‍💼',
      location: 'Tokyo, Japan',
      image: '🏯',
      description: 'Traditional temple visit in Kyoto. The peaceful atmosphere here is incredible.',
      likes: 89,
      comments: 12,
      time: '4 hours ago'
    },
    {
      id: 3,
      author: 'Emma Wilson',
      avatar: '👩‍🎨',
      location: 'Santorini, Greece',
      image: '🏛️',
      description: 'Blue domes and white buildings - Santorini is pure magic at sunset!',
      likes: 156,
      comments: 23,
      time: '6 hours ago'
    }
  ];

  return (
    <div className="overview-content">
      {/* Share Adventure Section */}
      <div className="share-adventure-section">
        <h3>Share Your Last Adventure</h3>
        <div className="share-adventure-card">
          <div className="share-input-wrapper">
            <Avatar 
              src={userPicture}
              alt="Your Avatar"
              size="medium"
              className="user-avatar-post"
            />
            <textarea
              className="adventure-input"
              placeholder="Tell us about your last adventure..."
              value={adventureText}
              onChange={(e) => setAdventureText(e.target.value)}
              rows={3}
            />
          </div>
          <div className="share-actions">
            <div className="share-options">
              <button className="share-option-btn" title="Add photo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                  <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button className="share-option-btn" title="Add location">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </button>
              <button className="share-option-btn" title="Add emoji">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="9" cy="9" r="1" fill="currentColor"/>
                  <circle cx="15" cy="9" r="1" fill="currentColor"/>
                </svg>
              </button>
            </div>
            <button 
              className="post-adventure-btn" 
              onClick={handlePostAdventure}
              disabled={!adventureText.trim()}
            >
              Post
            </button>
          </div>
        </div>
      </div>

      {/* Feed Section */}
      <div className="feed-section">
        <h3>Travel Feed</h3>
        <div className="feed-posts">
          {tripPosts.map(post => (
            <div key={post.id} className="feed-post">
              <div className="post-header">
                <div className="author-info">
                  <Avatar 
                    src={post.avatar}
                    alt={post.author}
                    size="medium"
                    className="author-avatar"
                  />
                  <div className="author-details">
                    <h4>{post.author}</h4>
                    <p>{post.location}</p>
                  </div>
                </div>
                <span className="post-time">{post.time}</span>
              </div>
              
              <div className="post-image">
                <div className="image-placeholder">
                  <span className="image-icon">{post.image}</span>
                </div>
              </div>
              
              <div className="post-content">
                <p>{post.description}</p>
              </div>
              
              <div className="post-actions">
                <button className="action-btn">
                  ❤️ {post.likes}
                </button>
                <button className="action-btn">
                  💬 {post.comments}
                </button>
                <button className="action-btn">
                  📤 Share
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
